<template>
  <card class="bg-gradient-success total-values-card" style="border-radius: 12px; border: 0;">
    <div v-if="title">
      <h4 class="font-weight-800 text-white">
        {{ title }}
      </h4>
    </div>
    <div v-if="loading" class="loading-spinner-container">
      <div class="loading-spinner"></div>
    </div>
    <div v-else class="subtitle text-white">
      <div v-if="Object.keys(totalValues).length === 0">
        <h3 class="font=weight-700 text-white">
          {{ error }}
        </h3>
      </div>
      <div v-else v-for="(grupo, index) in totalValues" :key="index">
        <hr v-if="index !== 'meta_financeira'" style="border-top: 1px solid rgba(255, 255, 255, 0.4); margin: 10px 0" />
        <p class="font-weight-700" style="margin-bottom: 0">
          {{ formatLabel(index) }}
        </p>
        <p class="value font-weight-700">
          {{ grupo | currency }}
        </p>
      </div>
    </div>
  </card>
</template>

<script setup>
import { defineProps } from 'vue';

const props = defineProps(['totalValues', 'loading', 'title', 'error']);

const formatLabel = (label) => {
  return label.replace(/_/g, ' ').toUpperCase();
};
</script>

<style scoped>
.total-values-card p {
  font-size: 12px !important;
}
</style>
